export default "__VITE_ASSET__D3qMrivs__"